(function(){
	$('#error-popup .close').on( "click", function() {
		$.magnificPopup.close();
	  });
	$('#success-popup .close').on( "click", function() {
		$.magnificPopup.close();
	  });
})();